import type { NotifyResponses } from '@patrianna/shared-patrianna-types/websocket/notifications'

import { gatewayErrorInstance } from 'services/gateway'
import { WSinstance } from 'services/websocket'
import wsNotifyHandler from 'services/websocket/wsNotifyHandler'
import type { TypedThunk } from 'store/types'

import type { MiddlewareType } from './types'

export const initSocketListeners = (): TypedThunk => (dispatch) => {
  const socketRoot = WSinstance.getInstance()

  if (!socketRoot || socketRoot?.readyState !== WebSocket.OPEN) {
    console.log('ws logs:  initSocketListeners when socket closed')
    // sentry logs
  } else {
    socketRoot.onmessage = (resp) => {
      try {
        const event = JSON.parse(resp.data)

        console.log(`ws logs:  message ${event.body.type}`, event)

        // notify events
        if (!event.status) {
          dispatch(wsNotifyHandler(event as { body: NotifyResponses }))

          return null
        }

        // resp events
        const { status } = event
        // handle all response errors from websocket
        if (status.errorCode !== 'err_ok') {
          dispatch(gatewayErrorInstance.errorHandler(event, {}))
        }
      } catch (error) {
        console.log('WSinstance.node.onmessage - error', error)
      }

      return null
    }

    socketRoot.onclose = (event) => {
      console.log('ws logs:  onclose event', {
        code: event.code,
        reason: event.reason,
        wasClean: event.wasClean,
      })

      WSinstance.clear()

      // do not reconnect browser tab is not active
      if (document.hidden) {
        return null
      }

      // do not reconnect when socket disconnected by user using WSinstance.disconnect()
      if (event.code === 4444) {
        return null
      }

      // reconnect
      WSinstance.connect(dispatch)

      return null
    }

    socketRoot.onerror = (error) => {
      console.log('ws logs: onerror event', error)
    }
  }
}

export const initSocketListenersMiddleware: MiddlewareType = (store) => (next) => (action) => {
  if (action.type === 'INIT_SOCKET_LISTENERS') {
    console.log('INIT_SOCKET')
    store.dispatch(initSocketListeners())
  }

  next(action)
}
